import React from 'react';
import ToolTip from './ToolTip';
import '../css/HeatPump.css';

const HeatPumpType = (props) => {
	const validClass = (props.validation.isInvalid) ? "app__form-input--error" : "";
	const options_obj = (props.province) ? props.content.heatpump[props.province] : '';
	const options = (typeof options_obj === 'object') ? options_obj : [];
	const display = (props.display) ? '' : 'app__form-group--hide';
	let items = [];
	if (typeof options_obj === 'object') {
		for (let option in options) {
			let item_obj = options[option];
			items.push(<option key={item_obj.value} value={item_obj.value} label={item_obj.type}>{item_obj.type}</option>);
		}
	}

	return (
		<div className={`app__form-group app__form-group--with-tooltip ${display}`}>
			<label htmlFor="emco_heatpumptype">
				{props.content.heatPumpLabel}
			</label>
			<select className={`app__form-select ${validClass}`} id="emco_heatpumptype" name="heatpumptype" value={props.heatpumptype} onChange={props.handleChange}>
				<option value="">{props.content.selectPrompt}</option>
				{items}
			</select>
			<ToolTip content={props.content.heatpumptooltip} />
			<div className="app__form--error">{props.validation.message}</div>
		</div>
	);
}

export default HeatPumpType;


// WEBPACK FOOTER //
// ./src/components/HeatPumpType.js